var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as ngCommon from '@angular/common';
import { NgModule } from '@angular/core';
import { DiagramTemplateService } from './diagram-template.service';
import { LayerService } from './layer.service';
import { FractionDigitService } from './utils/fraction-digit.service';
import { FlowDirectionService } from './utils/pipe/flow-direction.service';
import { BarDirectionService } from './utils/bar-graph/bar-direction.service';
import { DiagramCompileService } from './diagram-compile.service';
import { ElementFactory } from './elements/base/element.factory';
import { SizeService } from './utils/common/size.service';
import { PointService } from './utils/common/point.service';
import { NumericalOperationService } from './utils/numerical-display/numerical-operation.service';
import { DateTimeService } from './utils/date-time/date-time.service';
import { AbpModule } from 'abp-ng2-module/src/abp.module';
var DiagramModule = /** @class */ (function () {
    function DiagramModule() {
    }
    DiagramModule = __decorate([
        NgModule({
            imports: [
                ngCommon.CommonModule,
                AbpModule
            ],
            providers: [
                DiagramTemplateService,
                LayerService,
                FractionDigitService,
                FlowDirectionService,
                BarDirectionService,
                DiagramCompileService,
                ElementFactory,
                SizeService,
                PointService,
                DateTimeService,
                NumericalOperationService
            ]
        })
    ], DiagramModule);
    return DiagramModule;
}());
export { DiagramModule };
